import React from 'react';
import { Box, BoxProps, CircularProgress, alpha } from '@mui/material';

type LoadingOverlayProps = BoxProps & {
  loaderSize?: number;
  rounded?: boolean;
};
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loaderSize = 80, rounded }) => {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      position='absolute'
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={100}
      bgcolor={(theme) => alpha(theme.palette.background.paper, 0.9)}
      borderRadius={rounded ? 2 : 0}
    >
      <CircularProgress size={loaderSize} />
    </Box>
  );
};
